module.exports = __webpack_public_path__ + "static/media/p208motor3.24261a68.jpg";